import { useQuery } from '@tanstack/react-query';

import { ScheduleMessage } from '../../../types/ScheduleMessage';
import { queries } from '../api/queryKeys/queries';
import { addUtcDays, endOfUtcDayIso, startOfUtcDayIso } from '../helpers/dateFns.helper';

import { useRole } from './useRole';

export interface Schedule extends ScheduleMessage {
    timeZoneId: string;
    rank: number;
}

interface UseSchedulesOptions {
    imo?: string;
    offerId?: string;
    scheduleSharingEnabled?: boolean;
}

export const useSchedules = ({ imo, offerId, scheduleSharingEnabled }: UseSchedulesOptions) => {
    const role = useRole();

    const etdFrom = startOfUtcDayIso(new Date());
    const etdTo = endOfUtcDayIso(addUtcDays(new Date(), 120));

    const listQuery = useQuery({
        ...queries.schedules.list({ imo: imo ?? '', etdFrom, etdTo }),
        enabled: !!imo && !role.isSupplier(),
    });

    const sharedQuery = useQuery({
        ...queries.schedules.shared(offerId ?? ''),
        enabled: !!offerId && role.isSupplier() && scheduleSharingEnabled === true,
    });

    const query = role.isSupplier() ? sharedQuery : listQuery;

    return {
        ...query,
        schedules:
            query.data
                ?.filter((schedule) => schedule.port)
                .map(
                    (schedule, index): Schedule => ({
                        ...schedule,
                        timeZoneId: schedule.port!.timeZoneId,
                        rank: index + 1,
                    })
                ) ?? [],
    };
};
